import { createIcon } from '../icons/utils';

export const ProcessedWithoutNoteIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_12305_23867)">
        <path d="M1 7.64126C1 6.93395 1.3736 6.27924 1.98254 5.91941L10.9825 0.601225C11.6102 0.230362 12.3898 0.230363 13.0175 0.601225L22.0175 5.91941C22.6264 6.27924 23 6.93395 23 7.64126V19.5C23 20.6046 22.1046 21.5 21 21.5H3C1.89543 21.5 1 20.6046 1 19.5V7.64126Z" />
        <path
          d="M23.92 7.69159C23.84 7.43572 23.712 7.21184 23.552 7.01994C23.36 6.79606 23.152 6.65213 22.816 6.44424L21.392 5.51673C21.392 5.51673 21.344 5.48474 21.328 5.46875L14.384 0.959103C13.632 0.479353 13.216 0.207495 12.688 0.0795617C12.24 -0.0323799 11.76 -0.0323799 11.312 0.0795617C10.784 0.207495 10.368 0.479353 9.616 0.959103L1.184 6.44424C0.848 6.65213 0.64 6.79606 0.448 7.01994C0.288 7.21184 0.16 7.43572 0.08 7.69159C0 7.96345 0 8.20332 0 8.61911V16.8228C0 18.8218 0 19.8293 0.448 20.7248C0.848 21.5084 1.488 22.148 2.272 22.5478C3.168 22.9956 4.176 22.9956 6.176 22.9956H17.824C19.824 22.9956 20.832 22.9956 21.728 22.5478C22.512 22.148 23.136 21.5084 23.552 20.7248C24 19.8293 24 18.8218 24 16.8228V8.61911C24 8.20332 24 7.96345 23.92 7.69159ZM2.56 7.53167C2.624 7.40374 3.088 7.0999 3.552 6.81205L10.32 2.41434L10.48 2.3024C11.088 1.9186 11.424 1.69472 11.664 1.63075C11.888 1.58278 12.112 1.58278 12.336 1.63075C12.576 1.69472 12.912 1.9186 13.52 2.3024L20.544 6.87602C20.96 7.14787 21.376 7.41973 21.44 7.51568C21.472 7.59564 21.472 7.69159 21.44 7.75556C21.376 7.88349 20.912 8.18733 20.448 8.47518L19.328 9.2108C18.08 6.39627 15.264 4.42929 12 4.42929C8.736 4.42929 5.92 6.39627 4.672 9.2108L3.536 8.47518C3.088 8.18733 2.624 7.88349 2.56 7.77155C2.528 7.69159 2.528 7.59564 2.56 7.53167ZM18.4 12.4411C18.4 13.2247 18.256 13.9923 17.984 14.6799C17.792 15.2077 17.536 15.6874 17.216 16.1352C16.064 17.7663 14.16 18.8378 12 18.8378C9.84 18.8378 7.936 17.7663 6.784 16.1352C6.464 15.6874 6.208 15.2077 6.016 14.6799C5.744 13.9923 5.6 13.2247 5.6 12.4411C5.6 12.2012 5.616 11.9774 5.632 11.7375C5.696 11.1778 5.84 10.6181 6.048 10.1063C6.976 7.72357 9.296 6.02846 12 6.02846C14.704 6.02846 17.024 7.72357 17.952 10.1063C18.16 10.6181 18.304 11.1778 18.368 11.7375C18.384 11.9774 18.4 12.2012 18.4 12.4411ZM1.6 16.8228V9.06687C1.856 9.29076 2.208 9.51464 2.672 9.81848L4.176 10.794C4.064 11.3217 4 11.8814 4 12.4411C4 13.6565 4.272 14.7919 4.752 15.8154L1.616 18.6459C1.6 18.1661 1.6 17.5744 1.6 16.8228ZM21.008 21.1246C20.448 21.3964 19.568 21.3964 17.824 21.3964H6.176C4.432 21.3964 3.552 21.3964 2.992 21.1246C2.64 20.9327 2.336 20.6768 2.096 20.357L5.584 17.2066C7.056 19.1736 9.376 20.4369 12 20.4369C14.624 20.4369 16.944 19.1736 18.4 17.2066L21.888 20.357C21.664 20.6768 21.36 20.9327 21.008 21.1246ZM22.4 16.8228C22.4 17.5744 22.4 18.1661 22.384 18.6459L19.248 15.8154C19.728 14.7919 20 13.6565 20 12.4411C20 11.8814 19.936 11.3217 19.824 10.794L21.328 9.81848C21.792 9.51464 22.128 9.29076 22.4 9.06687V16.8228Z"
          className={innerClassName}
          style={{ stroke: 'none' }}
        />
        <path
          d="M15.808 10.844L15.424 11.2279L11.488 15.1625C11.488 15.1625 11.376 15.2585 11.312 15.2904C11.184 15.3544 11.056 15.3864 10.928 15.3864C10.72 15.3864 10.512 15.3224 10.352 15.1625L8.19199 13.0032C7.91999 12.7153 7.88799 12.2835 8.11199 11.9636C8.12799 11.9316 8.15999 11.8996 8.19199 11.8676C8.51199 11.5637 9.00799 11.5637 9.32799 11.8676L10.928 13.4671L14.672 9.70839C14.992 9.4045 15.488 9.4045 15.808 9.70839C16.112 10.0283 16.112 10.5241 15.808 10.844Z"
          className={innerClassName}
          style={{ stroke: 'none' }}
        />
      </g>
      {/* Legacy pads this glyph's box by 4 units in both axes
          (`addHorizontal/VerticalIfProcessedNoNotes`, progressBarsSeries L720-726) so
          the "no note recorded" badge overhangs the envelope's bottom-right corner
          instead of covering it. The envelope keeps the 24x23 box the other processed
          glyph uses — the clipPath still bounds it — and the caller shifts the whole
          icon down-right by half the padding so that envelope stays on the lane's
          shared centre. Circle geometry is legacy's, from green-processed-noNote.svg. */}
      <circle
        cx={20.5}
        cy={19.5}
        r={6.5}
        fill="white"
        stroke="hsl(var(--themed-red-600))"
        strokeWidth={1.5}
      />
      <path
        d="M20.5 20.15V16.25M20.5 22.425H20.5065"
        stroke="hsl(var(--themed-red-600))"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_12305_23867">
          <rect width="24" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  {
    displayName: 'ProcessedWithoutNoteIcon',
    defaultSize: 22,
    classNameBase: '',
  },
);
